import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const initState = () => ({
  error: null,
  isLoading: false,
  certificate: null,
  course: null,
  courses: [],
  lesson: null,
  quizzes: [],
  result: null,
  summary: null,
});

export default {
  namespaced: true,
  state: initState(),
  getters,
  mutations,
  actions,
};
